import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { FlagsFilterService } from '../../../shared/services/filter-services/flags-filter.service';
import { StudentPathsFilterService } from '../../../shared/services/filter-services/studentPaths-filter.service';
import { ContentToolsModule } from '../../../shell/content-tools/content-tools.module';
import { ListDisplayStudentModule } from '../list-display/list-display-student/list-display-student.module';
import { PostsecondaryMadLibModule } from './postsecondary-list-mad-lib/postsecondary-mad-lib.module';
import { PostsecondaryListComponent } from './postsecondary-list.component';
import { PostsecondaryListService } from './postsecondary-list.service';

@NgModule({
  declarations: [PostsecondaryListComponent],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatSelectModule,
    MatGridListModule,
    FormsModule,
    ListDisplayStudentModule,
    MatMenuModule,
    ContentToolsModule,
    PostsecondaryMadLibModule,
  ],
  exports: [PostsecondaryListComponent],
  providers: [FlagsFilterService, StudentPathsFilterService, PostsecondaryListService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class PostsecondaryListModule {
  /** */
}
